export default __webpack_public_path__ + "static/media/dia2.68d9a816.png";